import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportComponent } from './components/import/import.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListImportsComponent } from './components/list-imports/list-imports.component';
import { UploadProcessingComponent } from './components/upload-processing/upload-processing.component';
import { ImportationSucceedComponent } from './components/importation-succeed/importation-succeed.component';
import { DetailsImportsComponent } from './components/details-imports/details-imports.component';
import { PreviewErrorsComponent } from './components/preview-errors/preview-errors.component';
import { ImportFilterComponent } from './components/import-filter/import-filter.component';



@NgModule({
  declarations: [
    ImportComponent,
    ListImportsComponent,
    UploadProcessingComponent,
    ImportationSucceedComponent,
    DetailsImportsComponent,
    PreviewErrorsComponent,
    ImportFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class ImportsModule { }
